import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppyPractitionerCardInterface } from 'src/app/core/model/v2/AppyPractitionerCardInterface';

@Component({
  selector: 'app-appy-practitioner-name-label',
  templateUrl: './appy-practitioner-name-label.component.html',
  styleUrls: ['./appy-practitioner-name-label.component.scss']
})
export class AppyPractitionerNameLabelComponent implements OnInit {

  @Input()
  AppyPractitioner : AppyPractitionerCardInterface;

   @Output() 
   click = new EventEmitter();
  
  constructor() { }

  ngOnInit() {
  }

  onClick()
  {
    this.click.emit();
  }
}
